<a (click)="goBack()" *ngIf="!iframeOrigin" class="twoColTemplate-rightHeaderNavLeftButton back-btn" [class.back-disabled]="activeWindow == 1 || disableBackBtn == true">
  <svg class="icon-rtlFlip" width="20px" height="20px">
    <use xlink:href="assets/images/icons.svg#back"></use>
  </svg>
  <span *ngIf="buttonText" class="mx-2">{{ buttonText | translate }}</span>
</a>
<!-- <a class="twoColTemplate-rightHeaderNavRightButton" style="color: #4c4c4c"></a> -->